import React, { Fragment, useEffect, useState } from 'react';
import $ from 'jquery';
import Navbar from './components/marketplace/Navbar';
import Layerslide from './components/marketplace/Layerslide';
import AdvancedSearch from './components/marketplace/AdvancedSearch';
import ItemsContent from './components/marketplace/ItemsContent';
import Footer from './components/marketplace/Footer';
import Loader from 'react-loader-spinner';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import apiUrl from './constants.js';
import './index.css';

function App() {

  const [logo, setLogo] = useState('');
  const [copyright, setCopyright] = useState('');
  const [faviconImage, setFaviconImage] = useState('');
  const [menuItems, setMenuItems] = useState([]);
  const [layerslideItems, setLayerslideItems] = useState([]);
  const [items, setItems] = useState([]);
  const [itemStore, setItemStore] = useState([]);
  const [itemsBkp, setItemsBkp] = useState([]);
  const [facebookUrl, setFacebookUrl] = useState('');
  const [terms, setTerms] = useState('');
  const [privacy, setPrivacy] = useState('');
  const [instagramUrl, setInstagramUrl] = useState('');
  const [searchColor, setSearchColor] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [navbarColor, setNavbarColor] = useState('#ffffff');
  const [navbarTextColor, setNavbarTextColor] = useState('#ffffff');
  const [storeBoxColor, setStoreBoxColor] = useState('#ffffff');
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [storeStatus, setStoreStatus] = useState([]);
  const [loader, setLoader] = useState(false);
  const [initialLoader, setInitialLoader] = useState(true);
  const [filters, setFilters] = useState({
    citiesFilter: '',
    categoriesFilter: '',
    searchFilter: '',
    onlyOpen: false
  });
  const [data, setData] = useState({});

  const useStyles = makeStyles(() => ({
    spinnerDiv: {
      height: '300px',
      width: '100%',
      textAlign: 'center',
    },
    spinner: {
      marginTop: '200px',
      marginBottom: '100px'
    },
    spinnerDivInit: {
      position: 'fixed',
      width: '100%',
      height:'100%',
      display: 'flex',
      alignItems: 'center',
      top: '0'
    },
    spinnerInit: {
      display: 'flex',
      margin: '0 auto',
    },
    mainDiv: {
      backgroundColor: backgroundColor,
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    getGeneralInfo();
  }, []);

  const getGeneralInfo = () => {
    let city_prefix = process.env.REACT_APP_CITY_PREFIX;
    let url = apiUrl+"v1/get-website-info";

    if(typeof city_prefix !== "undefined"){
      url = url + "?city_prefix="+city_prefix;
    }

    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    )
    .then(function (response) {
      if(response.data.redirect){
        window.location.href = response.data.redirect_url;
      } else {
        setLogo(response.data.logoImage);
        setMenuItems(response.data.menuItems);
        setData(response.data);
        setLayerslideItems(response.data.layerSlideImages);
        setCopyright(response.data.copyright);
        setItems(response.data.items);
        setItemsBkp(response.data.items);
        setFacebookUrl(response.data.facebook_url);
        setInstagramUrl(response.data.instagram_url);
        setSearchColor(response.data.searchColor);
        setCities(response.data.cities);
        setCategories(response.data.categories);
        setStoreStatus(response.data.storeStatus);
        setBackgroundColor(response.data.backgroundColor);
        setNavbarColor(response.data.navbarColor);
        setStoreBoxColor(response.data.storeBoxColor);
        setNavbarTextColor(response.data.navbarTextColor);
        setFaviconImage(response.data.faviconImage);
        setTerms(response.data.termAndConditions);
        setPrivacy(response.data.privacyPolicy);

        setInitialLoader(false);
      }

    })
    .catch(function (error) {
      console.log(error);
    });
  };

  const searchWithFilters = () => {
    setLoader(true);
    if(filters.citiesFilter==="" && filters.categoriesFilter==="" && filters.searchFilter===""  && filters.onlyOpen===false){
      setItems(itemsBkp);
      setItemStore([]);
      setLoader(false);
    } else {

      let city_prefix = process.env.REACT_APP_CITY_PREFIX;
      let url = apiUrl+"v1/get-items-filtered";

      let data = new FormData();

      if(typeof city_prefix !== "undefined"){
        data.append("city_prefix", city_prefix);
      }

      for ( var key in filters ) {
        data.append(key, filters[key]);
      }

      axios.post(url, data, {})
      .then(function (response) {
        console.log(response.data.items);
        setItems(response.data.items.first_row);
        setItemStore(response.data.items.second_row);
        console.log(response.data.items.second_row);
        setLoader(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoader(false);
      });

    }
    console.log(filters);
  };

  return (
    <Fragment>
      {
        !initialLoader ?
          <div className={classes.mainDiv}>
            <Navbar
              logo={logo}
              menuItems={menuItems}
              navbarColor={navbarColor}
              navbarTextColor={navbarTextColor}
            />

            {
              layerslideItems.length>0 ?
                <Layerslide
                  images={layerslideItems}
                  faviconImage={faviconImage}
                  data={data}
                />
              :
              null
            }

            <AdvancedSearch
              searchColor={searchColor}
              cities={cities}
              categories={categories}
              storeStatus={storeStatus}
              searchWithFilters={searchWithFilters}
              filters={filters}
              setFilters={setFilters}
            />
            {
              loader ?
                <div className={classes.spinnerDiv}>
                   <Loader
                     type="Oval"
                     color="#00BFFF"
                     height={50}
                     width={50}
                     className={classes.spinner}
                   />
                 </div>
              :
                <Fragment>
                  {
                    itemStore.length>0 && itemStore[0].board.columns.length>0 ?
                      <ItemsContent
                        items={itemStore}
                        setItems={setItemStore}
                        storeBoxColor={storeBoxColor}
                      />
                    :
                      null
                  }

                  <ItemsContent
                    items={items}
                    setItems={setItems}
                    storeBoxColor={storeBoxColor}
                  />
                </Fragment>
            }


            <Footer
              instagramUrl={instagramUrl}
              facebookUrl={facebookUrl}
              logo={logo}
              copyright={copyright}
              terms={terms}
              privacy={privacy}
            />
          </div>
        :
          <div className={classes.spinnerDivInit}>
             <Loader
               type="Oval"
               color="#00BFFF"
               height={50}
               width={50}
               className={classes.spinnerInit}
             />
           </div>
      }

    </Fragment>
  );
}

export default App;
